var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"my-1 ml-1 contractor-chip",attrs:{"data-contractor":_vm.contractor_cd,"small":"","color":_vm.chipColor}},[_vm._v(_vm._s(_vm.contractorName))])}
var staticRenderFns = []

export { render, staticRenderFns }